import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  paper: {
    border: "1px solid #E2E2E2",
    borderRadius: "4px",
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    height: "200px",
  },
  companyName: {
    fontWeight: 600,
    color: theme.palette.primary.main,
    whiteSpace: "nowrap",
    marginTop: theme.spacing(1),
  },
}))

export default styles
